import axios from 'axios'
import config from '../constants/Configs'
import { ActionType } from '../constants/ActionTypes'
import { Constants } from '../constants/Constants'
import { RestPath } from '../constants/SitePaths'
import { LanguageService } from '../services/LanguageService'
import { HeaderDeviceTypeEnum } from '../constants/DeviceTypeEnum'
import { Browser } from '../services/helpers/Browser'
import { getSeoSettingsSuccess } from './seo/SeoSettingsAction'
import store from '../'

export const getPromotionsCategoriesBegin = () => ({
    type: ActionType.GET_PROMOTIONS_CATEGORIES_BEGIN
})

export const getPromotionsCategoriesError = (data) => ({
    type: ActionType.GET_PROMOTIONS_CATEGORIES_ERROR,
    payload: data
})
export const getPromotionsCategoriesSuccess = (data) => ({
    type: ActionType.GET_PROMOTIONS_CATEGORIES_SUCCESS,
    payload: data
})

export const setPromotionKey = (data) => ({
    type: ActionType.SET_PROMOTIONS_KEY,
    payload: data
})

export const getPromotionsBegin = () => ({
    type: ActionType.GET_PROMOTIONS_BEGIN
})
export const getLoadMoreBegin = () => ({
    type: ActionType.GET_LOAD_MORE_BEGIN
})
export const getLoadMoreSuccess = (data) => ({
    type: ActionType.GET_LOAD_MORE_SUCCESS,
    payload: data
})
export const getPromotionsError = (data) => ({
    type: ActionType.GET_PROMOTIONS_ERROR,
    payload: data
})
export const getPromotionsSuccess = (data) => ({
    type: ActionType.GET_PROMOTIONS_SUCCESS,
    payload: data
})

export const getPromotionBegin = () => ({
    type: ActionType.GET_PROMOTION_BEGIN
})
export const getPromotionError = (data) => ({
    type: ActionType.GET_PROMOTION_ERROR,
    payload: data
})
export const getPromotionSuccess = (data) => ({
    type: ActionType.GET_PROMOTION_SUCCESS,
    payload: data
})
export const getRandomPromotionsBegin = () => ({
    type: ActionType.GET_RANDOM_PROMOTIONS_BEGIN
})
export const getRandomPromotionsError = (data) => ({
    type: ActionType.GET_RANDOM_PROMOTIONS_ERROR,
    payload: data
})
export const getRandomPromotionsSuccess = (data) => ({
    type: ActionType.GET_RANDOM_PROMOTIONS_SUCCESS,
    payload: data
})

export const getHighlightPromotionsBegin = () => ({
    type: ActionType.GET_HIGHLIGHT_PROMOTIONS_BEGIN
})
export const getHighlightPromotionsError = (data) => ({
    type: ActionType.GET_HIGHLIGHT_PROMOTIONS_ERROR,
    payload: data
})
export const getHighlightPromotionsSuccess = (data) => ({
    type: ActionType.GET_HIGHLIGHT_PROMOTIONS_SUCCESS,
    payload: data
})

export function getPromotionsCategories() {
    const l = LanguageService.getSelectedLanguage();
    return dispatch => {
        dispatch(getPromotionsCategoriesBegin())
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_PROMOTIONS_CATEGORIES,
            params: { l }
        }).then((response) => {
            dispatch(getPromotionsCategoriesSuccess(response.data))
            response.data.forEach(element => {
                dispatch(getSeoSettingsSuccess(
                    {
                        languageId: LanguageService.getSelectedLanguage(),
                        alias: 'promotionCategory' + element.id
                    }, {
                    description: element.seoDescription,
                    keywords: element.seoKeywords,
                    title: element.seoTitle,
                }));
            });
            dispatch(getSeoSettingsSuccess(response.data))
            return response.data
        }).catch((error) => {
            if (error.response) {
                dispatch(getPromotionsCategoriesError(error.response.data))
            } else {
                dispatch(getPromotionsCategoriesError(error))
            }
        })
    }
}

export function getPromotion(params) {
    const l = LanguageService.getSelectedLanguage();
    return dispatch => {
        dispatch(getPromotionBegin())
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_PROMOTION,
            params: { ...params, l }
        }).then((response) => {
            dispatch(getPromotionSuccess(response.data))
            const element = response.data;
            dispatch(getSeoSettingsSuccess(
                {
                    languageId: LanguageService.getSelectedLanguage(),
                    alias: 'promotion' + element.id
                }, {
                description: element.seoDescription,
                keywords: element.seoKeywords,
                title: element.seoTitle,
            }))
        }).catch((error) => {
            if (error.response) {
                dispatch(getPromotionError(error.response.data))
            } else {
                dispatch(getPromotionError(error))
            }
            return true
        })
    }
}

export function getPromotions(params, bLoadMore) {
    const l = LanguageService.getSelectedLanguage();
    const d = Browser.getHeaderDeviceType();
    const p = Browser.getMobilePlatform();
    if(p)params.p = p;
    const targetGroup = store.getState().user?.playerData?.player?.targetGroups;
    if(targetGroup) params['targetGroup'] = targetGroup[0];

    return dispatch => {
        bLoadMore ? dispatch(getLoadMoreBegin()) : dispatch(getPromotionsBegin())
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_PROMOTIONS,
            params: { ...params, l, d }
        }).then((response) => {
            bLoadMore ? dispatch(getLoadMoreSuccess(response.data)) : dispatch(getPromotionsSuccess(response.data))
            return response.data
        }).catch((error) => {
            if (error.response) {
                dispatch(getPromotionError(error.response.data))
            } else {
                dispatch(getPromotionError(error))
            }
        })
    }
}

export function getRandomPromotions(params) {
    const l = LanguageService.getSelectedLanguage();
    const d = Browser.getHeaderDeviceType();
    return dispatch => {
        dispatch(getRandomPromotionsBegin())
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_RANDOM_PROMOTIONS,
            params: { ...params, l, d }
        }).then((response) => {
            dispatch(getRandomPromotionsSuccess(response.data))
        }).catch((error) => {
            if (error.response) {
                dispatch(getRandomPromotionsError(error.response.data))
            } else {

                dispatch(getRandomPromotionsError(error))
            }
        })
    }
}

export function getHighlightPromotions(params) {
    const l = LanguageService.getSelectedLanguage();
    const d = Browser.getHeaderDeviceType();
    const targetGroups = store.getState().user?.playerData?.player?.targetGroups;
    if(targetGroups) params['targetGroup'] = targetGroups[0];
    
    return dispatch => {
        dispatch(getHighlightPromotionsBegin())
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_HIGHLIGHT_PROMOTIONS,
            params: { ...params, l, d }
        }).then((response) => {
            dispatch(getHighlightPromotionsSuccess(response.data))
        }).catch((error) => {
            if (error.response) {
                dispatch(getHighlightPromotionsError(error.response.data))
            } else {

                dispatch(getHighlightPromotionsError(error))
            }
        })
    }
}
